'use client';
import { Provider, Root, Trigger, Portal, Content, Arrow } from '@radix-ui/react-tooltip';
import { ComponentProps, FunctionComponent, ReactNode } from 'react';
import styles from './styles.module.scss';

export type TooltipProps = {
    children: ComponentProps<typeof Trigger>['children'];
    tooltip: string | ReactNode;
};

export const Tooltip: FunctionComponent<TooltipProps> = ({ tooltip, children }) => {
    return (
        <Provider>
            <Root>
                <Trigger asChild>{children}</Trigger>
                <Portal>
                    <Content className={styles.tooltip} sideOffset={5}>
                        {tooltip}
                        <Arrow className={styles.tooltipArrow} />
                    </Content>
                </Portal>
            </Root>
        </Provider>
    );
};
